import React from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'


const ConfirmationModal = ({ showModal, cancelClicked, confirmClicked, children }) => {
    return (
        <ReactModal
            isOpen={showModal}
            className="confirmation-modal"
            overlayClassName="confirmation-modal-overlay"
            onRequestClose={cancelClicked}
            contentLabel="Confirmation">
            <div className="confirmation-modal-question">
                <h2>{children}</h2>
            </div>
            <div className="confirmation-modal-button">
                <button className="btn btn-primary btn-sm" onClick={confirmClicked}>Yes</button>
                &#160;
                <button className="btn btn-default btn-sm" onClick={cancelClicked}>Cancel</button>
            </div>
        </ReactModal>

    )
}

ConfirmationModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    confirmClicked: PropTypes.func.isRequired,
    cancelClicked: PropTypes.func.isRequired,
}

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/modules/form/component/ConfirmationModal.js